const navigation =
[
    {
        id       : 'nav-xyz',
        title    : 'XYZ Platform',
        type     : 'group',
        icon     : 'apps',
        children :
        [
            {
                id    : 'item-home',
                title : 'Accueil',
                type  : 'item',
                icon  : 'home',
                url   : '/home'
            }
        ]
    }
];

export default navigation ;


// WEBPACK FOOTER //
// ./src/app/locale/fr/navigation.js